// extracted by mini-css-extract-plugin
module.exports = {"NavContent":"NavCard_NavContent__gdDzM","Card":"NavCard_Card__1J9U5"};